<template>
  <div class="not-found">
    <img src="../assets/img/sad.svg">
    <h1>Такой страницы нет</h1>

    <router-link to="/" class="btn btn-primary">
      На главную
    </router-link>
  </div>
</template>

<script>
  export default {
    name: 'NotFound',
  }
</script>

<style lang="sass">
  .page-notfound
    img
      max-width: 100px
      margin-bottom: 30px
    .btn
      margin-top: 30px
    .container
      display: flex
      align-items: center
      justify-content: center
      text-align: center
</style>
